module.exports = __webpack_public_path__ + "img/icon-service-system-2.cff9bbed.svg";